import { AxiosResponse } from "axios";

import {
  IAddWardRequest,
  IUpdateWardConfigurationRequest,
  IUpdateWardRequest,
  IWard,
  TWardConfigurationResponse,
} from "../../@types/admin/AdminWard";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * Wards admin pages (EN-5151), migrated from the Retool Wards app. The list
 * endpoint takes optional filters and pagination; both are omitted so the
 * whole catalogue comes back for client-side search, as Retool's table did.
 */
export const wardsService = {
  async getWards(): Promise<AxiosResponse<IPaginatedResponse<IWard[]>>> {
    return api.get<IPaginatedResponse<IWard[]>>("/Retool/Wards");
  },

  async getWardById(wardId: number): Promise<AxiosResponse<IWard>> {
    return api.get<IWard>(`/Retool/Wards/${wardId}`);
  },

  async addWard(request: IAddWardRequest): Promise<AxiosResponse<IWard>> {
    return api.post<IWard>("/Retool/Wards", request);
  },

  async updateWard(request: IUpdateWardRequest): Promise<AxiosResponse<IWard>> {
    return api.put<IWard>(`/Retool/Wards/${request.id}`, request);
  },

  /**
   * Full replace of the ward's feature configuration (EN-5195) — the write
   * path for everything `updateWard` deliberately leaves alone.
   */
  async updateWardConfiguration(
    wardId: number,
    request: IUpdateWardConfigurationRequest
  ): Promise<AxiosResponse<TWardConfigurationResponse>> {
    return api.put<TWardConfigurationResponse>(
      `/Retool/Wards/${wardId}/Configuration`,
      request
    );
  },
};
